<template lang="html">
  <div class="auth-form flex flex-col">
    <Transition name="fade" :duration="300" mode="out-in">
      <SignInFormContainer
        v-if="action === AuthFormAction.signIn"
        :key="AuthFormAction.signIn"
        :type="loginType"
        :show-login-type-tabs="showLoginTypeTabs"
        :allowed-login-types="allowedLoginTypes"
        @update:type="loginType = $event"
        @submit="emit('submit')"
        @go-to="emit('goTo', $event)"
      />
      <SignUpFormContainer
        v-else-if="action === AuthFormAction.signUp"
        :key="AuthFormAction.signUp"
        :type="loginType"
        :show-login-type-tabs="showLoginTypeTabs"
        :allowed-login-types="allowedLoginTypes"
        @update:type="loginType = $event"
        @submit="emit('submit')"
        @go-to="emit('goTo', $event)"
      />
    </Transition>
  </div>
</template>

<script setup lang="ts">
import SignInFormContainer from './SignInFormContainer.vue'
import SignUpFormContainer from './SignUpFormContainer.vue'
import { LoginInputType, AuthFormAction } from './type'

import {
  getAllowedLoginTypes,
  getDefaultLoginType,
} from '#Auth/support/loginType'

const props = withDefaults(
  defineProps<{
    action: AuthFormAction
  }>(),
  {},
)
const emit = defineEmits<{
  submit: []
  goTo: [action: AuthFormAction]
}>()

const { store } = useAuth()

const allowedLoginTypes = computed(() => getAllowedLoginTypes(store.config))
const showLoginTypeTabs = computed(() => allowedLoginTypes.value.length > 1)
const loginType = ref<LoginInputType>(getDefaultLoginType(store.config))

watch(
  () => props.action,
  () => {
    loginType.value = getDefaultLoginType(store.config)
  },
)

watch(allowedLoginTypes, (types) => {
  if (!types.includes(loginType.value)) {
    loginType.value = getDefaultLoginType(store.config)
  }
})
</script>
